/* eslint-disable no-console*/

import base from './default.json';
const ENV =
  process.env.REACT_APP_MUNDIALITO_ENV || process.env.NODE_ENV || 'dev';

let overrides = {};

try {
  overrides = require(`./${ENV}.json`) || {};
  console.log(`Config: Using ${ENV}.json`);
} catch (e) {
  console.log(`Config: ${ENV}.json Not Found, using defaults.json`);
}

export default Object.assign({}, base, overrides);
